<template>
	<div class="page-content">
		<div class="student-head-content">
			<div class="search-wrapper">
				<ja-input
					v-model="studentFilter"
					escape-string
					class="large"
					name="search"
					:placeholder="$t('searchByName')"
					@keyup.native.enter="searchStudent"
				/>
			</div>
			<ja-button name="search" class="small" @click.native="searchStudent">
				{{ $t('search') }}
			</ja-button>
			<div class="add-student-wrapper">
				<ja-add-button @click.native="openModalNewUser">
					{{ $t('addNewStudent') }}
				</ja-add-button>
			</div>
		</div>
		<div
			v-if="students.length || favoriteStudents.length"
			class="student-content-wrapper"
		>
			<!-- display all favorite students -->
			<ja-dashboard-container
				v-if="favoriteStudentsCount"
				:title="$t('titleFavoriteStudents')"
				:number-msg="favoriteStudentsCount"
			>
				<content>
					<div class="sort-header">
						<ja-dropdown
							v-model="favStudsSortingOptionIndex"
							:options="sortingOptions"
							name="sortFavStudents"
							:label="$t('sortBy')"
							@input="refetchStudentsData"
						></ja-dropdown>
					</div>

					<ja-students-list
						:items="favoriteStudents"
						:facility="selectedFacilityId"
						@openCompletedCategories="openModal"
						@forceLifeStage="onOpenConfirmationDialog"
						@refetchData="refetchStudentsData"
					></ja-students-list>
					<ja-pagination
						:current="favoriteStudentsCurrentPage"
						:data-per-page="favoriteStudentsPerPage"
						:data-count="favoriteStudentsCount"
						@changePage="setFavoriteStudentsPage"
					></ja-pagination>
				</content>
			</ja-dashboard-container>

			<!-- display all students section -->
			<ja-dashboard-container
				v-if="allStudentsCount"
				:title="$t('titleAllStudents')"
				:number-msg="allStudentsCount"
				class="main-dashboard"
			>
				<content>
					<div class="sort-header">
						<ja-dropdown
							v-model="studsSortingOptionIndex"
							:options="sortingOptions"
							name="sortAllStudents"
							:label="$t('sortBy')"
							@input="refetchStudentsData"
						></ja-dropdown>
					</div>

					<ja-students-list
						:items="students"
						:facility="selectedFacilityId"
						@openCompletedCategories="openModal"
						@forceLifeStage="onOpenConfirmationDialog"
						@refetchData="refetchStudentsData"
						@itemSelected="itemSelectedStudent"
						@modalOpened="isModalOpen"
					></ja-students-list>
					<ja-add-career-student-modal
						:show="showOpenModalAddCareer"
						:student="studentSelected"
						:facility-id="selectedFacilityId"
						@closeModalAddCareer="onModalAddCareerClose"
					></ja-add-career-student-modal>

					<ja-pagination
						:current="allStudentsCurrentPage"
						:data-per-page="allStudentsPerPage"
						:data-count="allStudentsCount"
						@changePage="setAllStudentsPage"
					></ja-pagination>
				</content>
			</ja-dashboard-container>
		</div>
		<div v-else-if="!requestMade" class="no-results">
			<h5>{{ $t('noResultsFound') }}</h5>
		</div>

		<ja-completed-categories-modal
			:show="showCompletedCatModal"
			:title-first-part="selectedStudent.firstName"
			:title-second-part="selectedStudent.lastName"
			:completed-items="selectedStudent.completedCategoriesForCurrentLifeStage"
			:incompleted-items="filteredCategories"
			:asset-item-path="expenseCategories"
			@closeModalCompletedCategories="onModalCompletedCategoriesClose"
		></ja-completed-categories-modal>

		<ja-add-student-modal
			:show="showAddNewStudentModal"
			@closeModalNewUser="onModalNewUserClose"
			@usersImportingStarted="onImportStarted"
			@usersImportingFinished="onImportFinished"
			@loadingStart="onLoadingStart"
			@loadingStop="onLoadingStop"
		></ja-add-student-modal>

		<ja-confirm-modal
			:show="showCompleteLifeStageModal"
			title=""
			class="confirm-modal--large"
			@confirm="forceLiveStangeConfirmed"
			@closeModal="onCloseCompleteLifeStageModal"
			@cancel="onCloseCompleteLifeStageModal"
		>
			<h3>{{ $t('forcedCompleteLifeStageStudentFromAdmin') }}</h3>
		</ja-confirm-modal>
	</div>
</template>

<script>
import '../../icons/more';

import AdminFacility from '@/mixins/AdminFacility';
import '../../icons/expenseCategories';
import AddButton from '../elements/AddButton';
import DashboardContainer from '../elements/DashboardContainer';
import AddStudentModal from '../modals/AddStudentModal';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/form/Input';
import Dropdown from '@/components/ui/form/Dropdown';
import CompletedCategoriesModal from '../modals/CompletedCategoriesModal';
import Pagination from '../elements/Pagination';
import gql from 'graphql-tag';
import StudentsService from '@/services/StudentsService';
import ConfirmModal from '@/components/Modal/ConfirmModal';
import { studentsSources } from '@/helpers/constants';
import { StudentsList } from '@/components/ui';
import AddCareerStudentModal from '@/components/AdminSection/modals/AddCareerStudentModal';
export default {
	components: {
		jaDashboardContainer: DashboardContainer,
		jaAddStudentModal: AddStudentModal,
		jaButton: Button,
		jaInput: Input,
		jaDropdown: Dropdown,
		jaCompletedCategoriesModal: CompletedCategoriesModal,
		jaAddButton: AddButton,
		jaPagination: Pagination,
		jaConfirmModal: ConfirmModal,
		jaStudentsList: StudentsList,
		jaAddCareerStudentModal: AddCareerStudentModal
	},
	mixins: [AdminFacility],

	data() {
		return {
			students: [],
			favoriteStudents: [],
			allStudentsCount: 0,
			favoriteStudentsCount: 0,
			studsSortingOptionIndex: 0,
			favStudsSortingOptionIndex: 0,
			sortingOptions: [
				{ name: this.$t('firstName'), value: 'firstName' },
				{ name: this.$t('lastName'), value: 'lastName' }
			],
			selectedStudent: {},
			showAddNewStudentModal: false,
			showFileExtensionWarning: false,
			showAddNewStudentContentSecond: false,
			showCompletedCatModal: false,
			alertIsVisible: false,
			showImportInfo: true,
			importResult: null,
			requestMade: true,
			expenseCategories: 'expenseCategories/',
			searchQuery: '',
			allStudentsCurrentPage: 1,
			allStudentsPerPage: 15,
			favoriteStudentsCurrentPage: 1,
			favoriteStudentsPerPage: 5,
			studentFilter: '',
			importing: false,
			tabName: 'Students',
			showCompleteLifeStageModal: false,
			selectedStudForLSComplition: null,
			studentSelected: null,
			showOpenModalAddCareer: false
		};
	},
	computed: {
		filteredCategories() {
			let allCategories = this.selectedStudent
				.availableCategoriesForCurrentLifeStage;
			let completedCategories = this.selectedStudent
				.completedCategoriesForCurrentLifeStage;

			if (!allCategories) {
				return [];
			}

			const mapComplеted = completedCategories.map(i => i.name);

			return allCategories.filter(i => mapComplеted.indexOf(i.name) === -1);
		}
	},
	watch: {
		selectedFacility() {
			this.onLoadingStart();
			this.refetchStudentsData();
		},
		students() {
			this.onLoadingStop();
			this.$store.commit('setLoading', false);
			this.onLoadingStop();
		}
	},
	mounted() {
		if (this.selectedFacilityId != null) {
			this.$store.commit('setLoading', true);
			this.refetchStudentsData();
		}
	},
	methods: {
		itemSelectedStudent(student) {
			this.studentSelected = student;
		},
		onOpenConfirmationDialog(student) {
			this.showCompleteLifeStageModal = true;
			this.selectedStudForLSComplition = student;
		},
		onCloseCompleteLifeStageModal() {
			this.showCompleteLifeStageModal = false;
		},
		async forceLiveStangeConfirmed() {
			this.$store.commit('setLoading', true);
			const student = this.selectedStudForLSComplition;
			const studentInfo = {
				id: student.id,
				isTransferToNextLifeStagePending: true,
				source: studentsSources.FINANCE_PARK
			};

			await this.$apollo
				.mutate({
					mutation: gql`
						mutation($update: StudentInputObjectGraphType!) {
							updateIgnoreNullValuesStudent(update: $update) {
								id
							}
						}
					`,
					variables: {
						update: studentInfo
					}
				})
				.then(response => {
					if (response.data) {
						this.showCompleteLifeStageModal = false;
					}
				})
				.catch(e => e)
				.finally(() => {
					this.$store.commit('setLoading', false);
				});
		},
		async getAllStudents() {
			const sortBy = `${
				this.sortingOptions[this.studsSortingOptionIndex].value
			}`;
			const skip = Math.max(
				(this.allStudentsCurrentPage - 1) * this.allStudentsPerPage,
				0
			);
			const { data } = await StudentsService.getStudentsBasedOnUsers(
				this.selectedFacilityId,
				this.searchQuery,
				{ sort: sortBy, skip, take: this.allStudentsPerPage }
			);

			if (data) {
				this.requestMade = false;
				this.allStudentsCount = data.allStudents;
				this.students = data.users;
			}
		},
		async getAllFavoriteStudents() {
			const sortBy = `${
				this.sortingOptions[this.favStudsSortingOptionIndex].value
			}`;
			const skip = Math.max(
				(this.favoriteStudentsCurrentPage - 1) * this.favoriteStudentsPerPage,
				0
			);

			const { data } = await StudentsService.getStudentsBasedOnUsers(
				this.selectedFacilityId,
				this.searchQuery,
				{ sort: sortBy, skip, take: this.favoriteStudentsPerPage },
				{ favoritesOnly: true, userId: this.userData.userId }
			);

			if (data) {
				this.requestMade = false;
				this.favoriteStudentsCount = data.allStudents;
				this.favoriteStudents = data.users;
			}
		},

		updateTemplates() {
			// force paginations to go to first page
			this.allStudentsCurrentPage = 1;
			this.favoriteStudentsCurrentPage = 1;
		},

		async refetchStudentsData() {
			if (this.selectedFacility != null) {
				this.$emit('loadingStartForAdmin');

				await Promise.all([
					this.getAllStudents(),
					this.getAllFavoriteStudents()
				]);
				this.updateTemplates();
				this.onLoadingStop();
			}
		},
		openModal(student) {
			this.showCompletedCatModal = true;
			this.$emit('modalOpened');
			this.selectedStudent = student;
		},
		onModalCompletedCategoriesClose() {
			this.showCompletedCatModal = false;
			this.$emit('modalClosed');
			this.selectedStudent = {};
		},
		async setAllStudentsPage(page) {
			this.$emit('loadingStartForAdmin');
			this.allStudentsCurrentPage = page;
			await this.getAllStudents();
			this.onLoadingStop();
		},
		async setFavoriteStudentsPage(page) {
			this.$emit('loadingStartForAdmin');
			this.favoriteStudentsCurrentPage = page;
			await this.getAllFavoriteStudents();
			this.onLoadingStop();
		},
		openModalNewUser() {
			this.showAddNewStudentModal = true;
			this.$emit('modalOpened');
		},
		onModalNewUserClose() {
			this.showAddNewStudentModal = false;
			this.$emit('modalClosed');
		},
		onImportStarted() {
			this.importing = true;
			this.resetSearchField();
		},
		onImportFinished() {
			this.importing = false;
			this.refetchStudentsData();
		},
		resetSearchField() {
			this.studentFilter = '';
			this.searchQuery = '';
		},
		onLoadingStart() {
			this.$emit('loadingStartForAdmin');
		},
		onLoadingStop() {
			if (!this.importing) {
				this.$emit('loadingStopForAdmin');
			}
		},
		searchStudent() {
			if (this.searchQuery != this.studentFilter) {
				this.onLoadingStart();
				this.searchQuery = this.studentFilter;
				this.requestMade = true;
			}
			this.refetchStudentsData();
		},
		isModalOpen(open) {
			this.showOpenModalAddCareer = open;
		},
		onModalAddCareerClose() {
			this.showOpenModalAddCareer = false;
			this.$emit('modalClosed');
		}
	}
};
</script>
<style lang="scss" scoped>
.page-content {
	flex-grow: 1;

	.dashboard-container {
		margin-top: 32px;
	}

	.student-head-content {
		margin: auto;
		max-width: 1000px;
		margin-top: 32px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		justify-content: space-between;

		.search-wrapper {
			width: 300px;
			margin-right: 16px;
		}

		.add-student-wrapper {
			flex-grow: 1;
			text-align: right;
		}

		.btn-import {
			margin-left: 16px;
		}
	}

	.main-dashboard {
		padding-bottom: 84px;
	}
}
.sort-header {
	display: inline-block;
	padding: 8px 0 8px 16px;

	.dropdown-component {
		display: block;
		align-items: center;

		::v-deep label {
			margin: 0;
		}

		::v-deep .dropdown {
			width: 200px;
		}
	}
}

.facility-dropdown-container {
	margin: auto;
	width: 100%;
	margin: auto;
	max-width: 1000px;
	margin-top: 16px;
	margin-bottom: 32px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	justify-content: space-between;
}
.pagination {
	border-top: 1px solid $button-border;
}

.close-button-new-student {
	background-color: $font-blue;
	position: absolute;
	height: 38px;
	width: 38px;
	border-radius: 100%;
	right: 16px;
	top: 16px;
	outline: 0;
	border: 0;
	background-color: $container-bgcolor;
	@media (any-hover: hover) {
		&:hover {
			cursor: pointer;
			svg {
				fill: $hover-state;
			}
		}
	}

	svg {
		fill: $primary-state;
	}
}

// .add-student-menu {
// 	display: flex;
// }

.no-results {
	text-align: center;
	margin-top: 128px;
}

.external-loading-wrapper {
	opacity: 0.6;
}

.student-content-wrapper {
	position: relative;
}
</style>
